import { Plus, X } from "lucide-react";
import { useEffect, useId, type ReactNode } from "react";

interface AdminFormDialogProps {
  eyebrow: string;
  title: string;
  description: string;
  submitLabel: string;
  icon?: ReactNode;
  children: ReactNode;
  disabled?: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

export function AdminFormDialog({ eyebrow, title, description, submitLabel, icon, children, disabled = false, onCancel, onSubmit }: AdminFormDialogProps) {
  const titleId = useId();
  const descriptionId = useId();

  useEffect(() => {
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape" && !disabled) onCancel();
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [disabled, onCancel]);

  return (
    <div className="editor-overlay admin-form-overlay" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget && !disabled) onCancel(); }}>
      <section className="admin-form-dialog" role="dialog" aria-modal="true" aria-labelledby={titleId} aria-describedby={descriptionId}>
        <header className="admin-form-dialog-head">
          <span className="admin-form-dialog-icon">{icon || <Plus />}</span>
          <div><span>{eyebrow}</span><h2 id={titleId}>{title}</h2><p id={descriptionId}>{description}</p></div>
          <button type="button" onClick={onCancel} disabled={disabled} aria-label="Dialog schließen"><X /></button>
        </header>
        <form onSubmit={(event) => { event.preventDefault(); onSubmit(); }} noValidate>
          <div className="admin-form-dialog-body">{children}</div>
          <footer className="admin-form-dialog-actions">
            <button type="button" className="admin-secondary-button" onClick={onCancel} disabled={disabled}>Abbrechen</button>
            <button type="submit" className="admin-primary-button" disabled={disabled}><Plus /> {submitLabel}</button>
          </footer>
        </form>
      </section>
    </div>
  );
}
